import React from 'react';

export const UserContext = React.createContext();

export const TestletContext = React.createContext();
